import { render, staticRenderFns } from "./ShippingMethodsCompanyDelivery.vue?vue&type=template&id=bd4e7c36"
import script from "./ShippingMethodsCompanyDelivery.vue?vue&type=script&lang=js"
export * from "./ShippingMethodsCompanyDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports